import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  height: 84px;
  padding-top: 30px;
`;

export const Button = styled.button<{ selected: boolean }>`
  border: 0;
  border-bottom: ${props => props.selected ? '2px solid #6E30E9' : '0'};
  font-family: Inter-Medium;
  font-weight: bold;
  font-size: 15px;
  line-height: 125%;
  color: ${props => props.selected ? '#6E30E9' : '#4D4D4D'};
  background-color: transparent;
  width: 72px;
  height: 22px;
  cursor: pointer;
`;